/**
 * Builds a complete form-value map covering every known filter field.
 *
 * antd's `form.setFieldsValue` merges: it only updates the keys present in the
 * passed object and leaves omitted fields untouched. When syncing filters that
 * live in the URL/state into the modal form, a cleared filter is absent from the
 * incoming values and would therefore keep its stale value. By writing an entry
 * for every field (absent keys resolve to `undefined`), cleared filters are reset.
 */
export const buildCompleteFilterForm = <V>(
  fields: { name: keyof V }[],
  values: Partial<V>,
): Partial<V> => {
  const next: Partial<V> = {};
  fields.forEach((field) => {
    next[field.name] = values[field.name];
  });
  return next;
};
